import { Box } from '@mui/material';
import CardDTO from '@src/adapters/dto/card/CardDTO';
import ProcedureAutoComplete from '@src/components/procedure/ProcedureAutoComplete';
import ConsultantAutoComplete from '@src/components/consultant/ConsutlantAutoComplete';
import Notes from './notes/Notes';
import { CardNoteType } from '@src/constants/CardNoteType';
import CardNoteDTO from '@src/adapters/dto/card/CardNoteDTO';
import Files from './file/Files';

interface Props {
  card: CardDTO;
  isEdit: boolean;
  onNoteUpdated(note: CardNoteDTO): void;
  onNoteDeleted(noteId: string): void;
}

function DetailsTab({ card, isEdit, onNoteDeleted, onNoteUpdated }: Props) {
  return (
    <>
      <Box
        sx={(theme) => ({
          padding: theme.spacing(3),
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(2),
        })}>
        <ConsultantAutoComplete
          selectedId={card.consultant.id}
          enableNew={true}
          disabled={true}
        />
        <ProcedureAutoComplete
          selectedId={card.procedureId}
          enableNew={true}
          disabled={true}
        />
      </Box>
      <Box sx={{ paddingBottom: '20px' }}>
        <Notes
          cardId={card.id}
          notes={card.notes.filter((n) => n.type === CardNoteType.Scrub)}
          onNoteUpdated={onNoteUpdated}
          onNoteDeleted={onNoteDeleted}
          type={CardNoteType.Scrub}
          isEdit={isEdit}
        />
        <Notes
          cardId={card.id}
          notes={card.notes.filter((n) => n.type === CardNoteType.General)}
          onNoteUpdated={onNoteUpdated}
          onNoteDeleted={onNoteDeleted}
          type={CardNoteType.General}
          isEdit={isEdit}
        />
        <Files files={card.files} />
      </Box>
    </>
  );
}

export default DetailsTab;
